module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/8_ffe3571e1310219ff33fc0e10bc3daa6.jpg";